import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Define menu items with role access
// roles: array of roles that can see this item (empty = all roles)
const menuSections = [
  {
    title: 'Hoofdmenu',
    items: [
      { path: '/', icon: 'bi-speedometer2', label: 'Dashboard', roles: [] },
      { path: '/orders', icon: 'bi-inbox', label: 'Orders', roles: [] },
    ]
  },
  {
    title: 'Productie',
    items: [
      { path: '/production', icon: 'bi-play-circle', label: 'Productie Overzicht', roles: ['admin', 'operator'] },
      { path: '/cutlists', icon: 'bi-scissors', label: 'Snijlijsten', roles: ['admin', 'operator'] },
      { path: '/machines', icon: 'bi-gear-wide-connected', label: 'Machines', roles: ['admin', 'operator'] },
    ]
  },
  {
    title: 'Beheer',
    items: [
      { path: '/products', icon: 'bi-box', label: 'Producten', roles: ['admin', 'operator'] },
      { path: '/parts', icon: 'bi-box-seam', label: 'Materialen', roles: ['admin', 'operator'] },
    ]
  },
  {
    title: 'Systeem',
    items: [
      { path: '/users', icon: 'bi-people', label: 'Gebruikers', roles: ['admin'] },
      { path: '/settings', icon: 'bi-gear', label: 'Instellingen', roles: ['admin'] },
    ]
  }
];

const Sidebar = () => {
  const { user } = useSelector((state) => state.auth);
  const userRole = user?.role || 'viewer';

  // Filter menu items based on user role
  const filteredSections = menuSections
    .map(section => ({
      ...section,
      items: section.items.filter(item =>
        item.roles.length === 0 || item.roles.includes(userRole)
      )
    }))
    .filter(section => section.items.length > 0);

  return (
    <nav className="sidebar">
      <div className="sidebar-brand">
        <h6 className="mb-0 text-primary">Productie Dashboard</h6>
      </div>

      {filteredSections.map((section, idx) => (
        <div key={idx} className="sidebar-section">
          <h6 className="sidebar-heading">{section.title}</h6>
          <ul className="nav flex-column">
            {section.items.map((item) => (
              <li className="nav-item" key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  end={item.path === '/'}
                >
                  <i className={`bi ${item.icon}`}></i>
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};

export default Sidebar;
